import React from 'react';
import { useHistory } from 'react-router';
import {
  BADGE_STATE_COLORS,
  LOGS_TABLE_DISPLAY_SIZE,
} from '../../../../constants/dataTableConstants';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../../common/dataTable/DataTable';
import { getAllProcessingCertPurchases } from '../../../../api/accounts';
import { FETCH_PROC_CERT_PURCHASES } from '../../../../store/actions/actionTypes';
import { ACCOUNTS_CERTIFICATE_PURCHASE_URL } from '../../../../constants/routerUrl';

const ProcessingCertTable = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.accounts.procCertRequests);

  const columns = [
    { header: 'Invoice', accessor: 'orderId' },
    { header: 'Date', accessor: 'createdAt', isDate: true },
    { header: 'Range', accessor: 'certRange' },
    { header: 'Mill Name', accessor: 'millName' },
    { header: 'Quantity', accessor: 'noOfCopies' },
    { header: 'Total', accessor: 'total', currency: '৳' },
    {
      header: 'Status',
      accessor: 'status',
      isBadge: true,
      colorScheme: BADGE_STATE_COLORS,
    },
    {
      header: 'Action',
      accessor: 'status',
      isButton: true,
      actionScheme: [
        { group: 'UNPAID', variant: 'read', action: 'VIEW' },
        { group: 'PAID', variant: 'read', action: 'VIEW' },
      ],
    },
  ];

  const handleView = ({ rowObject }) => {
    history.push({
      pathname: ACCOUNTS_CERTIFICATE_PURCHASE_URL,
      state: { orderId: rowObject?.orderId, certFor: 'processing' },
    });
  };

  const actionObject = {
    VIEW: handleView,
  };

  const PAYMENT_STATUS = {
    name: 'Payment Status',
    choices: [
      { name: 'PAID', value: 'PAID' },
      { name: 'UNPAID', value: 'UNPAID' },
    ],
  };

  const handlePagination = async ({ page, pageSize, searchKey, startDate, endDate, selected }) => {
    dispatch({ type: FETCH_PROC_CERT_PURCHASES, payload: null });
    const params = {
      page,
      endDate,
      pageSize,
      searchKey,
      startDate,
      status: selected?.['Payment Status'],
    };
    const res = await getAllProcessingCertPurchases(params);
    if (res.data?.status === 200) {
      dispatch({ type: FETCH_PROC_CERT_PURCHASES, payload: res.data });
    } else {
      dispatch({ type: FETCH_PROC_CERT_PURCHASES, payload: { purchases: [] } });
    }
  };

  const handleSearch = async ({ searchKey, startDate, endDate, selected }) => {
    dispatch({ type: FETCH_PROC_CERT_PURCHASES, payload: null });
    const params = {
      endDate,
      searchKey,
      startDate,
      status: selected?.['Payment Status'],
    };
    const res = await getAllProcessingCertPurchases(params);
    if (res.data?.status === 200) {
      dispatch({ type: FETCH_PROC_CERT_PURCHASES, payload: res.data });
    } else {
      dispatch({ type: FETCH_PROC_CERT_PURCHASES, payload: { purchases: [] } });
    }
  };

  return (
    <DataTable
      topPanel
      keySearch
      dateRange
      isPaginated
      columns={columns}
      search={handleSearch}
      data={data?.purchases}
      actions={actionObject}
      currentPage={data?.page}
      paginate={handlePagination}
      entries={data?.totalEntries}
      currentPageSize={data?.pageSize}
      selectOptions={[PAYMENT_STATUS]}
      caption="Processing Certificates"
      pageSizes={LOGS_TABLE_DISPLAY_SIZE}
    />
  );
};

export default ProcessingCertTable;
